// --- FAQ Accordion ---
document.addEventListener('DOMContentLoaded', () => {
    const faqButtons = document.querySelectorAll('#faq button');
    faqButtons.forEach(button => {
      button.addEventListener('click', () => {
        const answer = button.nextElementSibling;
        const icon = button.querySelector('svg');
        const isOpening = answer.style.display === 'none';
  
        if (isOpening) {
          answer.style.display = 'block';
          if (icon) icon.classList.add('rotate-180');
          const questionText = button.querySelector('span')?.textContent?.trim();
          if (questionText) {
            if (typeof window.dataLayer === 'object') {
              window.dataLayer.push({
                'event': 'faq_interaction',
                'event_category': 'FAQ_Section',
                'event_label': 'FAQ_Expand',
                'value': questionText
              });
            } else {
              console.warn('dataLayer or sendGAEvent function not found for FAQ. GA event not sent.');
            }
          }
        } else {
          answer.style.display = 'none';
          if (icon) icon.classList.remove('rotate-180');
        }
      });
    });
  
    // --- Static Link Analytics (Now handled in partials) ---

});

const RAW_API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').trim();

function resolvePublicApiUrl(path) {
    if (!RAW_API_BASE_URL) {
        return path;
    }

    const normalizedBase = RAW_API_BASE_URL.replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
}
  
// --- Paddle Initialization for Retain on Index Page ---
async function initializePaddleForIndexRetain() {
    try {
      const response = await fetch(resolvePublicApiUrl('/api/billing/config'));
      if (!response.ok) {
        console.error('index-ui: Failed to fetch Paddle config for Retain:', response.statusText);
        return;
      }
      const paddleConfigData = await response.json();
  
      if (paddleConfigData && paddleConfigData.paddle_client_side_token && paddleConfigData.paddle_environment) {
        if (typeof Paddle === 'undefined' || typeof Paddle.Initialize === 'undefined') {
          document.addEventListener('PaddleReady', () => {
            Paddle.Environment.set(paddleConfigData.paddle_environment);
            Paddle.Initialize({
              token: paddleConfigData.paddle_client_side_token,
              pwCustomer: {}
            });
          });
          return;
        }
  
        Paddle.Environment.set(paddleConfigData.paddle_environment);
        Paddle.Initialize({
          token: paddleConfigData.paddle_client_side_token,
          pwCustomer: {}
        });
  
      } else {
        console.error('index-ui: Paddle client-side token or environment not found in config for Retain.');
      }
    } catch (error) {
      console.error('index-ui: Error initializing Paddle for Retain:', error.message || 'Unknown error');
    }
}

if (typeof Paddle !== 'undefined' && Paddle.Initialize) {
    initializePaddleForIndexRetain();
} else {
    document.addEventListener('PaddleReady', initializePaddleForIndexRetain);
}
